var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-blank-container"},[_c('answer-render',{ref:"answer",attrs:{"config":_vm.config}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('FormItem',{attrs:{"prop":"value","rules":_vm.rules}},[_c('div',{ref:"fillAnswer",staticClass:"fill-blank-answer"})])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68c6dc2f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/FillBlankBox/FillBlankBoxAnswer.vue
// module id = null
// module chunks = 